import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, NotFoundError } from '@fitness-force/models';;

import { environment } from '@fitness-force/environments';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { OpportunityBoardType } from '@fitness-force/enum';
import type { ClientCheckInResponse, CreateResponse } from '@fitness-force/models';

@Injectable({
  providedIn: 'root',
})
export class CheckInService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getWhoIsInTheClub(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CHECK_IN.GET_WHO_IS_IN_CLUB
          .replace('{tenant_id}', tenantId.toString()),
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCheckIns(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http
      .get(environment.BASE_URL + CONST_URL_SEGEMENTS.CHECK_IN.GET_CHECK_INS
        .replace('{tenant_id}', tenantId.toString()), {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getClientCheckIns(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.paramName, p.paramValue);
      });
    }
    return this.http
      .get(environment.BASE_URL + CONST_URL_SEGEMENTS.CHECK_IN.GET_CLIENT_CHECK_INS
        .replace('{tenant_id}', tenantId.toString()), {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markClientCheckedIn(tenantId: number, clientId: number, data: any) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CHECK_IN.MARK_CLIENT_CHECKED_IN
          .replace('{tenant_id}', tenantId.toString())
          .replace('{client_id}', clientId.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deleteClientCheckedIn(tenantId: number, checkedInId: number, checkInId:number) {
    return this.http
      .delete(environment.BASE_URL + CONST_URL_SEGEMENTS.CHECK_IN.DELETE_CHECK_IN
        .replace('{tenant_id}', tenantId.toString())
        .replace('{client_id}', checkedInId.toString())
        .replace('{check_in_id}', checkInId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCheckInsByClientId(clientId: number, allParams: Array<string> = []):Observable<ClientCheckInResponse> {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.paramName, p.paramValue);
      });
    }
    return this.http
      .get(`${environment.BASE_URL}/clients/${clientId}/check_ins`, {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
